class Hero {
    constructor() {
        this.setters()

        return;
    }

    setters() {
        this.body = document.querySelector('body')
        this.time = 1
        this.DOM = {
            $subtitle: document.querySelectorAll('.bg-hero__subtitle .indicator-color__span span'),
            $finishing: document.querySelector('.bg-hero__finishing .scramble-it'),
            $finishing_els: document.querySelectorAll('.bg-hero__finishing__spans span'),
            $bg_video_media: document.querySelector('.bg-hero__interactions '),
        }
        this.$hero = document.querySelector('.index .bg-hero') || document.querySelector('.bg-hero')


        this.animaDOM()
        this.mastersSpans()
        this.tl_master = gsap.timeline({})
            .add(this.tl_subtitle_scramb, '<')
            .add(this.tl_slide_scrambles, '<')


        this.bindEvents()
        this.observeHero()
    }

    animaDOM() {
        this.DOM.$finishing_els.forEach((el, index) => { if (index !== 0) { el.style.opacity = 1 } })

        this.tl_subtitle_scramb = gsap.timeline()
            .from('.bg-hero__subtitle, .bg-hero__finishing', { opacity: 0, duration: 0.001 })
            .add(() => {
                this.DOM.$subtitle.forEach(el => {
                    this.scrambleIt(el)
                })
            })
            .add(() => {
                this.scrambleIt(this.DOM.$finishing)
            })
    }


    mastersSpans() {
        this.tl_slide_scrambles = gsap.timeline({ repeat: -1 })
        this.DOM.$finishing_els.forEach((el, index) => {
            const text = el.textContent
            this.tl_slide_scrambles
                .fromTo(el, { scrambleText: { text: '' } }, {
                    scrambleText: {
                        text: text,
                        chars: "upperCase",
                        revealDelay: 0.3,
                        tweenLength: true,
                        speed: 5
                    }, duration: this.time, ease: 'none'
                }, '<%')
                .to(el, { delay: this.time * 1.2, duration: this.time * 0.85, scrambleText: { text: '' } })
        })
    }

    scrambleIt(el) {
        if (!el) return;
        const text = el.textContent
        gsap.to(el, {
            scrambleText: {
                text: text,
                chars: "upperCase",
                revealDelay: 0.3,
                tweenLength: true,
                speed: 5
            }, duration: this.time, ease: 'none'
        })
    }

    bindEvents() {
        this.DOM.$bg_video_media.addEventListener('click', () => {
            window.scrollTo({
                top: document.querySelector('[data-id="web-animations"] .to-anchor').offsetTop - window.innerHeight * 0.1,
                left: 0,
                behavior: "smooth",
            });
        })
    }

    observeHero() {
        if (!this.$hero || !this.body) return;

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.body.classList.add('is-hero')
                } else {
                    this.body.classList.remove('is-hero')
                }
            })
        }, { threshold: 0 })

        observer.observe(this.$hero)
    }
}
new Hero();
